@switch (specificTemplateName) {
  @case (templates.ComponentHistory) {
    <app-component-history-template
      [columnName]="columnName"
      [element]="element"
    ></app-component-history-template>
  }
  @case (templates.MaintenanceJobs) {
    <app-maintenance-template
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
    ></app-maintenance-template>
  }
  @case (templates.PerformJobSpareParts) {
    <app-perform-job-spare-parts-template
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
    ></app-perform-job-spare-parts-template>
  }
  @case (templates.StandardJobTemplates) {
    <app-standard-job-templates-template
      [columnName]="columnName"
      [element]="element"
    ></app-standard-job-templates-template>
  }
  @case (templates.Projects) {
    <app-projects-template
      [columnName]="columnName"
      [element]="element"
      [buttonFunctions]="buttonFunctions"
    ></app-projects-template>
  }
  @case (templates.ExportErrors) {
    <app-export-errors-template
      [columnName]="columnName"
      [element]="element"
    ></app-export-errors-template>
  }
  @case (templates.MarineManagerIssues) {
    <app-marine-manager-issues-template
      [columnName]="columnName"
      [element]="element"
    ></app-marine-manager-issues-template>
  }
  @case (templates.Log) {
    <app-maintenance-job-log-template
      [columnName]="columnName"
      [element]="element"
    ></app-maintenance-job-log-template>
  }
  @default {
    {{ element[columnName] }}
  }
}
